//formButtonLoading
export const FORM_BUTTON_LOADING = 'FORM_BUTTON_LOADING';
export const TICKETS_TABLE_LOADING = "TICKETS_TABLE_LOADING";
export const MODAL_BUTTON_LOADING = "MODAL_BUTTON_LOADING";
export const VIEW_TICKET_LOADING = "VIEW_TICKET_LOADING"